module.exports = __webpack_public_path__ + "static/media/story-8.8becad35.jpg";